import React from 'react';
import Modal from './Modal';

interface Props {
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: string;
	confirm: string;
}

const Prompt: React.FC<Props> = ({ onClose, onConfirm, title, message, confirm }) => {
	const handleConfirm = () => {
		onConfirm();
		onClose();
	};

	return (
		<Modal onClose={onClose} bg wrapperClassName="md:_w-1/2 _mx-2 md:_mx-auto">
			<h2 slot="header" className="_pt-2 _text-xl _font-bold _text-center">
				{title}
			</h2>
			<div className="_flex _flex-col _w-full _px-4 _pt-2 _text-center">
				<p className="_mb-6">{message}</p>

				<button className="_mb-4 _btn _btn-primary-action" onClick={handleConfirm}>
					{confirm}
				</button>

				<button className="_mb-4 _btn _btn-black" onClick={onClose}>
					Cancel
				</button>
			</div>
		</Modal>
	);
};

export default Prompt;
